/* eslint-disable no-param-reassign */
import type { IVideoSrcParserOptions } from "../types";
import { parseOpts } from "./parseOpts";

export const getYoutubeEmbedSrc = (
  url: string,
  opts: IVideoSrcParserOptions = {},
  isPdf = false,
) => {
  const id = parseYoutubeURL(url);
  if (id) url = "https://www.youtube.com/embed/" + id;
  else return "";

  const { controls, autoplay, loop } = parseOpts(opts, isPdf);

  url = url.replace(/[&?]?(mute|playlist|controls|autoplay|loop)=\d/gm, "");
  const s: string[] = [];
  s.push(`controls=${controls ? 1 : 0}`);
  s.push(`autoplay=${autoplay ? 1 : 0}`);
  if (loop) {
    s.push(`loop=1&playlist=${id}`);
  } else s.push("loop=0");
  s.push("mute=1");
  if (isPdf) s.push("t=0.1");

  return url + `?${s.join("&")}`;
};

export const parseYoutubeURL = (url: string) => {
  if (!url) return;
  if (/youtu\.?be/.test(url)) {
    let i;
    const patterns = [
      /youtu\.be\/([^#\&\?]{11})/, // youtu.be/<id>
      /\?v=([^#\&\?]{11})/, // ?v=<id>
      /\&v=([^#\&\?]{11})/, // &v=<id>
      /embed\/([^#\&\?]{11})/, // embed/<id>
      /\/v\/([^#\&\?]{11})/, // /v/<id>
      /shorts\/([^#\&\?]{11})/, // shorts/<id>
    ];

    // If any pattern matches, return the ID
    for (i = 0; i < patterns.length; ++i) {
      if (patterns[i].test(url)) {
        const match = patterns[i].exec(url);
        if (match) return match[1];
      }
    }

    // If that fails, break it apart by certain characters and look
    // for the 11 character key
    const tokens = url.split(/[\/\&\?=#\.\s]/g);
    for (i = 0; i < tokens.length; ++i) {
      if (/^[^#\&\?]{11}$/.test(tokens[i])) {
        return tokens[i];
      }
    }
  }
};

export const isYoutubeShort = (url: string): boolean => {
  return /youtube\.com\/shorts\//.test(url);
};

/** Returns metadata overrides for YouTube Shorts (9:16) or standard videos (16:9). */
export const getShortsMetadata = (isShort: boolean) => ({
  isShort,
  metadata: isShort ? { width: 9, height: 16 } : { width: 16, height: 9 },
  ...(isShort && { shape: "free" as const }),
});
